import "./_filAriane.scss";

import {ReactElement} from "react";
import {useNavigate} from "react-router-dom";

import iconArrow from "@/assets/iconArrowDark.svg";
import iconHome from "@/assets/iconHome.svg";

import Button from "../Button/Button";

export interface filAriane {
  libelle: string;
  link: string;
}

function FilAriane({arborescence}: {arborescence: filAriane[]}): ReactElement {
  const navigate = useNavigate();

  const ArianeNav = arborescence.map((item, index) => {
    const isNotLast = arborescence.length - 1 > index;
    return (
      <li key={index}>
        <Button
          label={item.libelle}
          className="filAriane-button"
          variant={isNotLast ? "secondary" : "disable"}
          disabled={!isNotLast}
          onClick={() => navigate(item.link)}
        />
        {isNotLast ? (
          <img
            className="filAriane-iconArrow"
            src={iconArrow}
            alt="icone flèche"
            loading="lazy"
          />
        ) : null}
      </li>
    );
  });
  return (
    <div>
      <ul className="filAriane">
        <li>
          <Button
            label="Accueil"
            className="filAriane-button"
            icon={iconHome}
            variant="secondary"
            onClick={() => navigate("/")}
          />
          <img
            className="filAriane-iconArrow"
            src={iconArrow}
            alt="icone flèche"
            loading="lazy"
          />
        </li>
        {ArianeNav}
      </ul>
    </div>
  );
}

export default FilAriane;
